import {SelectEntityItem} from 'components/SelectEntityItem'
import _ from 'lodash'
import React from 'react'
import {notEmpty} from 'views/Shared'
import {dioceseSchema} from "../../../apis/diocese";

const DioceseEntity = ({item, children, defaultItem}) => (
  <SelectEntityItem
    item={item}
    defaultItem={defaultItem}
    schema={dioceseSchema}>
    {(data) => children(data)}
  </SelectEntityItem>
)

export const DioceseEntities = ({items, children, defaultItem}) => (
  <SelectEntityItem
    item={items}
    defaultItem={defaultItem}
    schema={[dioceseSchema]}>
    {(data = []) => children(_.filter(data, notEmpty))}
  </SelectEntityItem>
)

export default DioceseEntity
